(function () {
    // Configs
    var $globalConf = $('.js-global-conf');
    var $conf = $('.js-conf');

    //GA4 - view offer detail
    viewOfferEventSE({
        id: offerData.offerID,
        title: offerData.title,
        company: offerData.company,
        salary: offerData.salary,
        profession: offerData.profession,
        experience: offerData.experience,
        education: offerData.educationLevel,
        sector: offerData.sector,
        equivalentPositions: offerData.equivalentPositions,
        industry: offerData.industry,
        location: offerData.location,
        quantity: offerData.vacancy,
        level: offerData.offerLevel,
        tags: offerData.keywords,
        contract: offerData.contract
    });

    // Modules
    var offerDetailsServices = new OfferDetailsServices();
    var applyOfferController = new ApplyOfferController({
        $globalConf: $globalConf,
        $conf: $conf,
        offerDetailsServices: offerDetailsServices
    });

    // Btn apply for mobile affix
    var $footer = $('.js-eesites-footer');
    var $applyOfferFixed = $('.js-eesites-fixed-buttons');

    // Char counter for textarea in offer share modal
    var $textAreaShare = $('.js-shareOffer');
    var $charCounterShare = $textAreaShare.next().find('.js-char-counter');
    var charCounterShareOffer = new CharCounter({
        controlToLimit: $textAreaShare,
        counterControl: $charCounterShare,
        maxCharacters: 300
    });;

    // Truncate offers name in Similar offers
    var $offerNameLink = $('.js-offer-name');
    var $publishDescription = $('.js-publish-description');

    // Share offer
    var $formShareOffer = $('form.js-offer-share');
    var $modalShare = $('.js-modal-share');
    var $formShareAlert = $formShareOffer.find('.js-form-alert');

    function evalFooterHeight() {
        footerHeight = $footer.outerHeight() + 85;
        return footerHeight;
    }

    function applyOffer(event) {
        event.preventDefault();

        var params = {};
        var $form = $(this);
        var url;

        params = $form.serialize();
        url = $form.attr('action');

        offerDetailsServices
            .getResults(params, url)
            .then(function (data) {
                console.log(data);
            })
            .fail(function (param) {
                console.log(param);
            });
    }

    


    function shareOffer(event) {
        event.preventDefault();

        $('.rc-alert').remove();
        var rcres = grecaptcha.getResponse();

        if (rcres.length !== 0) {
            if ($formShareOffer.valid() && rcres.length !== 0) {
                var params = $formShareOffer.serialize();
                
                var url = $formShareOffer.attr('action');

                offerDetailsServices
                    .getResults(params, url)
                    .then(function (data) {
                        eeGlobal.notification.clean();

                        $formShareOffer[0].reset();
                        grecaptcha.reset();
                        $modalShare.modal('hide');

                        $('.js-eesites-offer-notifications').html('');

                        eeGlobal.notification.success({
                            title: $conf.data('shared-title'),
                            copy: data.Message,
                            $target: $('.js-eesites-offer-notifications')
                        });

                        eeGlobal.notification.success({
                            title: $conf.data('shared-title'),
                            copy: data.Message
                        });

                    }).fail(function (data) {
                        eeGlobal.notification.clean();
                        grecaptcha.reset();

                        eeGlobal.notification.error({
                            title: $conf.data('shared-title'),
                            copy: data.statusText,
                            $target: $('.js-eesites-offer-notifications')
                        });
                    });
            }
        } else {
            $('.g-recaptcha').after('<span class="rc-alert" style="display: block; color: #d22c0b; font-size: 13px; font-family: \'Ubuntu\', \'Helvetica\', sans-serif; font-style: italic;">*Por favor, completa la verificaci&oacute;n del reCAPTCHA.</span>');
        }
    }

    $applyOfferFixed.affix({
        offset: {
            bottom: evalFooterHeight
        }
    });

    // Truncate offer name and description in similar offers
    $offerNameLink.add($publishDescription).trunk8({
        lines: 2,
        parseHTML: false,
        tooltip: false
    });

    $formShareOffer.on('submit', shareOffer);

    //Button Close Alerts
    // TODO: Include this functionality in notification module
    $('.alert .close').click(function () {
        $('.close').alert('close');
    });

    //Variables M�dulo Social Network
    var $confSocialNetwork = $('.js-config-social-network');
    var socialNetworkDataTitle = $confSocialNetwork.data('title');
    var socialNetworkDataUrl = $confSocialNetwork.data('url');
    var socialNetworkImgShareOfferHover = $confSocialNetwork.data('img-share-offer-hover');
    var socialNetworkImgShareOffer = $confSocialNetwork.data('img-share-offer');

    // Para que men� PC no se muestre en resposive
    function checkScreenSize() {
        $('.share-container').each(function () {
            const menu = $(this).find('.dropdown-menu');
            if (window.innerWidth <= 768) {
                menu.hide();
            }
        });
    }
    window.onload = checkScreenSize;
    window.onresize = checkScreenSize;

    //Tomar cada bloque de variables dentro de un divisor llamado "share-container" en _SocialNetWork
    //ya que si es Sitio y no Base se repite las varibles - se toman por clases
    $('.share-container').each(function (index) {
        const shareLink = $(this).find('.shareOffer');
        const menu = $(this).find('.dropdown-menu');
        const imgShareOffer = shareLink.find('img');
        const confirmationMessage = $(this).find('.copyMessage');

        // Alternar la visibilidad del men� cuando se hace clic en el bot�n de compartir
        shareLink.on('click', function (event) {
            event.preventDefault();

            if (menu.is(":visible")) {
                menu.hide();
            } else {
                $('.dropdown-menu').not(menu).hide();
                menu.show();
            }
        });

        // Cerrar el men� si se hace clic fuera de �l
        $(document).click(function (event) {
            if (!$(event.target).closest('.shareOffer').length) {
                menu.hide();
            }
        });

        // Aplicar hover para cambiar el �cono
        shareLink.on('mouseover', function () {
            imgShareOffer.attr('src', socialNetworkImgShareOfferHover);
        });

        shareLink.on('mouseout', function () {
            if (!menu.is(":visible")) {
                imgShareOffer.attr('src', socialNetworkImgShareOffer);
            }
        });

        // Copiar el enlace al portapapeles
        menu.find('.copy').on('click', function (event) {
            event.preventDefault();
            const currentUrl = window.location.href;
            const tempInput = document.createElement('input');
            tempInput.value = currentUrl;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            menu.hide();
            confirmationMessage.addClass('show');

            setTimeout(function () {
                confirmationMessage.removeClass('show');
            }, 2000);
        });

        //Compartir via m�vil
        $(this).find(".shareOfferXS").on("click", function (event) {
            event.preventDefault();

            if (navigator.share) {
                navigator.share({
                    title: socialNetworkDataTitle,
                    url: socialNetworkDataUrl
                });
            }
        });
    });

    //Cerrar los men�s al inicio del carge de la p�gina que es el Detalle de una Oferta
    $('.dropdownMenu').each(function () {
        $(this).hide();
    });
})();
